import { Trans } from '@lingui/react';
import { Link } from '../joy/Link';
import { type ComponentProps } from 'react';

export const TermsLink = ({
  children = <Trans id="Terms of Service" />,
  target = '_blank',
  ...props
}: ComponentProps<typeof Link>) => {
  return (
    <Link {...props} href="https://bolago.com/se/villkor-bolago-startuptools-ab/" target={target}>
      {children}
    </Link>
  );
};
